"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAppRoutes = exports.setupParentRoutes = exports.pathTo = exports.buildPaths = exports.flattenRoutes = void 0;
function flattenRoutes(routes) {
    return routes
        .map((route) => {
        return [route.routes ? flattenRoutes(route.routes) : [], route];
    })
        .flat(Infinity);
}
exports.flattenRoutes = flattenRoutes;
const combinePaths = (parent, child) => `${parent.replace(/\$/, "")}/${child.replace(/^\//, "")}`;
const buildPaths = (navigation, parentPath = "") => {
    return navigation.map((route) => {
        const path = combinePaths(parentPath, route.path);
        return {
            ...route,
            path,
            ...(route.routes && {
                routes: (0, exports.buildPaths)(route.routes, path),
            }),
        };
    });
};
exports.buildPaths = buildPaths;
function pathTo(route) {
    if (!route.parent) {
        return [route];
    }
    return [...pathTo(route.parent), route];
}
exports.pathTo = pathTo;
const setupParentRoutes = (routes, parentRoute) => {
    const routeWithParents = routes.map((route) => {
        const withParent = {
            ...route,
            ...(parentRoute && { parent: parentRoute }),
        };
        return {
            ...withParent,
            ...(withParent.routes && {
                routes: (0, exports.setupParentRoutes)(withParent.routes, withParent),
            }),
        };
    });
    return routeWithParents;
};
exports.setupParentRoutes = setupParentRoutes;
const generateAppRoutes = (routes) => {
    return flattenRoutes((0, exports.setupParentRoutes)((0, exports.buildPaths)(routes)));
};
exports.generateAppRoutes = generateAppRoutes;
